import * as React from 'react';
import {
    BrowserRouter,
    Route
} from "react-router-dom";
import Layout from './components/Layout';
import Home from './components/Home';
import FAQ from './components/FAQ';
import ForDevelopers from './components/ForDevelopers';
import Contact from './components/Contact';
import './custom.css'
import './dashboard.css'
import Login from './components/Login';
import ArchiveHistory from './components/ArchiveHistory';
import UserDashboard from './components/UserDashboard';
import UserDashboardRFCs from './components/UserDashboardRFCs';
import UserDashboardReports from './components/UserDashboardReports';
import RegisterUser from './components/RegisterUser';
import UserDashboardSideBar from './components/UserDashboardSideBar';
import NoticyOfPrivacy from './components/NoticyOfPrivacy';
import ValidateInvoice from './components/ValidateInvoice';
import { Routes } from 'react-router';
import Extension from './components/Extension';

function LogOut() {
    localStorage.removeItem("token");
    window.location.href = "/login";
    return (<></>);
}

let isLogged = localStorage.getItem("token");

function Dashboard() {
    return (<div className="row">
        <UserDashboardSideBar />
        <UserDashboard />
    </div>);
}


function MyRFC() {
    return (<div className="row">
        <UserDashboardSideBar />
        <UserDashboardRFCs />
    </div>);
}


function Reports() {
    return (<div className="row">
        <UserDashboardSideBar />
        <UserDashboardReports />
    </div>);
}

class App extends React.Component<{}, {}>{

    private logOut() {

    }

    public ClearCacheData() {
        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
    };

    public render() {
        this.ClearCacheData();
        return (
            <BrowserRouter>
                <Layout/>
                <Routes>
                    <Route path='/' Component={!isLogged ? Home : Dashboard} />
                    <Route path='/faq' Component={FAQ} />
                    <Route path='/forDevs' Component={ForDevelopers} />
                    <Route path='/contact' Component={Contact} />
                    <Route path='/noticyOfPrivacy' Component={NoticyOfPrivacy} />
                    <Route path='/login' Component={Login} />
                    <Route path='/logout'></Route>
                    <Route path='/register' Component={RegisterUser} />
                    <Route path='/archives' Component={ArchiveHistory} />
                    <Route path='/misrfcs' Component={MyRFC} />
                    <Route path='/reports' Component={Reports} />
                    <Route path='/invoiceValidation' Component={ValidateInvoice}/>
                    <Route path='/chrome-ext' Component={Extension}/>
                </Routes>
            </BrowserRouter>);
    }
}

export default App;